import { createWorker, PSM, type Worker } from "tesseract.js";

/**
 * The text-reference reader: a tesseract.js worker restricted to the
 * reference alphabet, loading its worker, WASM core and language data
 * from our own origin (/ocr, copied at build). Created when Reception
 * mounts so it's warm by the time Scan opens; terminated on leave.
 */
export interface RefOcr {
  recognise(source: HTMLCanvasElement): Promise<string>;
  terminate(): Promise<void>;
}

/** tesseract.js version the assets were copied from — the URL segment
 *  under /ocr. Keep in step with scripts/copy-ocr-assets.mjs. */
const OCR_ASSET_VERSION = "7.0.0";
const OCR_BASE = `/ocr/${OCR_ASSET_VERSION}`;

export async function createRefOcr(): Promise<RefOcr> {
  const worker: Worker = await createWorker("eng", 1, {
    workerPath: `${OCR_BASE}/worker.min.js`,
    corePath: OCR_BASE,
    langPath: OCR_BASE,
  });
  await worker.setParameters({
    tessedit_char_whitelist: "VYA-ABCDEFGHJKMNPQRSTUVWXYZ23456789",
    // A block, not a line: on a phone the reference often wraps.
    tessedit_pageseg_mode: PSM.SINGLE_BLOCK,
  });
  return {
    async recognise(source) {
      const { data } = await worker.recognize(source);
      return data.text;
    },
    terminate: () => worker.terminate().then(() => undefined),
  };
}
